import React from 'react';
import Component from '@vfuk/core-color-swatch';
const ColorSwatch = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ColorSwatch;
